module.exports = __webpack_public_path__ + "img/Check_your_Web_App_health_with_Lighthouse.5f8d7eaa.jpeg";